module.exports = __webpack_public_path__ + "static/media/blockchainAssets.1c3654a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/home/partners/images/blockchainAssets.png
// module id = 1828
// module chunks = 146